import { useEffect, useContext } from "react"
import { Card, Col, Container, Row, Alert, Button, Badge } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useLocation } from 'react-router-dom';
import { splitParagraphs, strToDateObject } from "../../tools/main";
import React from "react";
import AuthContext from "../../context/AuthProvider";
import { ArrowLeft, Calendar, Tag, Clock, ExclamationTriangle, Share } from "react-bootstrap-icons";

export default function OpportunityPage() {
    const { auth } = useContext(AuthContext)
    const navigate = useNavigate()
    const location = useLocation();
    const data = location.state?.data;
    
    useEffect(()=> {
        console.log(data)
        // If no data is passed, redirect back to opportunities
        if (!data) {
            navigate('/opportunities')
        }
    }, [data, navigate])

    // If no data, show loading or redirect
    if (!data) {
        return (
            <Container className="mt-150">
                <Row>
                    <Col className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }

    return (
        <Container className="mt-100 mb-5" style={{ maxWidth: '900px' }}>
            {/* Back Navigation */}
            <Button 
                variant="link" 
                className="mb-3 p-0 text-decoration-none d-inline-flex align-items-center"
                onClick={() => navigate('/opportunities')}
                style={{ fontSize: '0.9rem' }}
            >
                <ArrowLeft className="me-1" size={16} />
                Back to Opportunities
            </Button>

            {/* Main Content */}
            <Card className="border-0 shadow-sm">
                <Card.Body className="p-3 p-sm-4 p-md-5">
                    {/* Header with Share Button */}
                    <div className="d-flex justify-content-between align-items-start mb-4 flex-wrap gap-2">
                        <div className="flex-grow-1" style={{ minWidth: '0' }}>
                            <Badge 
                                bg="warning" 
                                text="dark"
                                className="mb-3"
                                style={{ 
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    padding: '0.4rem 0.8rem'
                                }}
                            >
                                {data.category || 'Opportunity'}
                            </Badge>
                            <h1 
                                className="mb-3" 
                                style={{ 
                                    fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                                    fontWeight: '600',
                                    lineHeight: '1.3',
                                    color: '#1a202c',
                                    wordWrap: 'break-word'
                                }}
                            >
                                {data.title}
                            </h1>
                        </div>
                        <Button 
                            variant="outline-secondary" 
                            size="sm"
                            className="d-flex align-items-center"
                            style={{ flexShrink: 0 }}
                            onClick={() => {
                                if (navigator.share) {
                                    navigator.share({
                                        title: data.title,
                                        text: data.description.substring(0, 100) + '...',
                                        url: window.location.href
                                    });
                                } else {
                                    navigator.clipboard.writeText(window.location.href);
                                    alert('Link copied to clipboard!');
                                }
                            }}
                        >
                            <Share className="me-1" size={14} />
                            <span className="d-none d-sm-inline">Share</span>
                        </Button>
                    </div>

                    {/* Meta Information */}
                    <div className="d-flex align-items-center text-muted mb-4 pb-4 border-bottom" style={{ fontSize: '0.875rem' }}>
                        <Calendar className="me-2 flex-shrink-0" size={16} />
                        <span>Posted {strToDateObject(data.date_created).toLocaleDateString('en-US', { 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                        })}</span>
                    </div>

                    {/* Description */}
                    <div className="mb-5">
                        <h2 
                            className="h5 mb-3" 
                            style={{ 
                                fontWeight: '600',
                                color: '#2d3748'
                            }}
                        >
                            About this Opportunity
                        </h2>
                        <div style={{ 
                            fontSize: '1rem',
                            lineHeight: '1.7',
                            color: '#4a5568'
                        }}>
                            {splitParagraphs(data.description).map((para, index) => (
                                <p key={index} className="mb-3" style={{ wordWrap: 'break-word' }}>
                                    {para}
                                </p>
                            ))}
                        </div>
                    </div>

                    {/* Action Section */}
                    <div className="pt-4 border-top">
                        {auth?.membershipstatus === 'Active' ? (
                            <>
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    className="w-100 w-sm-auto px-4 mb-3"
                                    onClick={() => window.location.href = 'mailto:info@csam-scma.ca?subject=Interest in ' + encodeURIComponent(data.title)}
                                >
                                    Express Interest
                                </Button>
                                <div 
                                    className="mt-3 p-3 rounded"
                                    style={{ 
                                        backgroundColor: '#f7fafc',
                                        fontSize: '0.875rem',
                                        color: '#4a5568'
                                    }}
                                >
                                    <strong>Next Steps:</strong> After expressing interest, you'll receive follow-up information 
                                    directly from the opportunity provider. Check your email for further details.
                                </div>
                            </>
                        ) : (
                            <Alert 
                                variant="info" 
                                className="border-0 mb-0"
                                style={{ backgroundColor: '#e6f7ff' }}
                            >
                                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">
                                    <div className="flex-grow-1">
                                        <ExclamationTriangle className="me-2" />
                                        <strong>Members Only:</strong> Join CSAM to access and apply for exclusive opportunities.
                                    </div>
                                    <Button 
                                        variant="warning"
                                        onClick={() => navigate('/membership')}
                                        className="flex-shrink-0 w-100 w-md-auto"
                                    >
                                        Become a Member
                                    </Button>
                                </div>
                            </Alert>
                        )}
                    </div>
                </Card.Body>
            </Card>

            {/* View More Link */}
            <div className="mt-4 text-center">
                <Button 
                    variant="link" 
                    onClick={() => navigate('/opportunities')}
                    className="text-decoration-none"
                    style={{ fontSize: '0.9rem' }}
                >
                    View More Opportunities →
                </Button>
            </div>
        </Container>
    )
}